module.exports = "<div *ngIf=\"maps\">\n  <cw-widget-map-list [widget]=\"widget\" [maps]=\"maps\"\n                      (mapDeleted)=\"onMapAdded($event)\"\n                      (mapAdded)=\"onMapAdded($event)\"\n                      (orderChanged)=\"onMapsOrderChange($event)\"></cw-widget-map-list>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget-detail/widget-detail-main/widget-detail-main.component.html
// module id = ./src/app/widgets/widget-detail/widget-detail-main/widget-detail-main.component.html
// module chunks = main